import { get } from '../core/config'
import type { Storage } from '../types/Storage';

let isInitialized: string[] = [];
let lsExists = true;

const getStoragePrefix = (applicationUid: string | null = null) => `chayns-logger_${applicationUid ? applicationUid : get('applicationUid')}_`;

const runtimeStorage: Record<string, string> = {}; // TODO: implement own storage class to reduce code-complexity

let storage: { applicationUid: string, applicationStorage: Storage }[] = [];

export function init(applicationUid: string | null = null) {
    try {
        const storagePrefix = getStoragePrefix(applicationUid);
        const testKey = `${storagePrefix}test123`;

        const applicationStorage = get('localStorage', applicationUid) || (typeof localStorage !== 'undefined' && localStorage) as Storage;
        if(!lsExists){
            applicationStorage.setItem(testKey, String(123));
            applicationStorage.getItem(testKey);
            applicationStorage.removeItem(testKey);

            lsExists = true;
        }

        if (applicationUid) {
            storage.push({
                applicationUid,
                applicationStorage
            });
        }
    } catch (err) {
        lsExists = false;
    }

    if (applicationUid) {
        isInitialized.push(applicationUid);
    }
}

function checkInit(applicationUid: string | null = null) {
    if (applicationUid) {
        return typeof isInitialized.find(isI => isI === applicationUid) !== 'undefined';
    }
    return typeof isInitialized[0] !== 'undefined';
}

function getApplicationStorage(applicationUid: string | null = null) {
    if (applicationUid) {
        const storageEntry = storage.find(entry => entry.applicationUid === applicationUid);
        return typeof storageEntry !== 'undefined' && storageEntry.applicationStorage;
    }
    return typeof storage[0] !== 'undefined' && storage[0].applicationStorage;
}

export function setItem(key: string, value: any, applicationUid: string | null = null) {
    if (!checkInit(applicationUid)) {
        init(applicationUid);
    }

    if (typeof value !== 'string') {
        value = JSON.stringify(value);
    }
    const applicationStorage = getApplicationStorage(applicationUid);
    if (lsExists && applicationStorage) {
        applicationStorage.setItem(`${getStoragePrefix(applicationUid)}${key}`, value);
    } else {
        const runtimeStorageKey = applicationUid ? `${key}_${applicationUid}` : key;
        runtimeStorage[runtimeStorageKey] = value;
    }
}

export function removeItem(key: string, applicationUid: string | null = null) {
    if (!checkInit(applicationUid)) {
        init(applicationUid);
    }
    const applicationStorage = getApplicationStorage(applicationUid);
    if (lsExists && applicationStorage) {
        applicationStorage.removeItem(`${getStoragePrefix(applicationUid)}${key}`);
    } else {
        const runtimeStorageKey = applicationUid ? `${key}_${applicationUid}` : key;
        if (runtimeStorageKey in runtimeStorage) {
            delete runtimeStorage[runtimeStorageKey];
        }
    }
}

export function getItem<T = any>(key: string, applicationUid: string | null = null): T | string | null {
    if (!checkInit(applicationUid)) {
        init(applicationUid);
    }

    let value;
    const applicationStorage = getApplicationStorage(applicationUid);
    if (lsExists && applicationStorage) {
        value = applicationStorage.getItem(`${getStoragePrefix(applicationUid)}${key}`);
    } else {
        const runtimeStorageKey = applicationUid ? `${key}_${applicationUid}` : key;
        value = runtimeStorage[runtimeStorageKey];
    }

    try {
        if (value === null) {
            return value;
        }

        return JSON.parse(value);
    } catch (e) {
        return value;
    }
}
